export const siteName = '萝卜影视';
export const siteTagline = '免费看电影 · 免费追剧 · 高清在线观看';
export const siteIntro = '萝卜影视汇聚海量高清电影与电视剧资源，每日实时更新最新大片、热门剧集和经典影视大全。无需注册、无需付费，打开即看，全程流畅不缓冲。从院线新片到怀旧老片，从国产佳作到海外精选，萝卜影视致力于为影迷提供一站式的免费影视在线观看体验。每周精选专题、编辑推荐榜单和用户热评，帮你快速找到值得看的好内容。';

export const heroStats = [
  { label: '收录影片', value: '12,800+' },
  { label: '每日更新', value: '60+' },
  { label: '高清片源', value: '95%' },
];

export const topics = [
  { id: 't1', name: '热门电影', heat: '128万讨论', icon: 'ri-fire-line' },
  { id: 't2', name: '高分剧集', heat: '96万讨论', icon: 'ri-star-line' },
  { id: 't3', name: '最新上线', heat: '85万讨论', icon: 'ri-rocket-line' },
  { id: 't4', name: '动作大片', heat: '73万讨论', icon: 'ri-flashlight-line' },
  { id: 't5', name: '喜剧精选', heat: '68万讨论', icon: 'ri-emotion-laugh-line' },
  { id: 't6', name: '悬疑烧脑', heat: '62万讨论', icon: 'ri-search-eye-line' },
  { id: 't7', name: '韩国综艺', heat: '55万讨论', icon: 'ri-tv-2-line' },
  { id: 't8', name: '国产剧集', heat: '51万讨论', icon: 'ri-film-line' },
  { id: 't9', name: '动漫番剧', heat: '47万讨论', icon: 'ri-ghost-line' },
  { id: 't10', name: '纪录片', heat: '39万讨论', icon: 'ri-earth-line' },
];

export const rankingItems = [
  { rank: 1, title: '流浪地球3', category: '科幻', score: '9.2', trend: 'up', views: '2,380万' },
  { rank: 2, title: '庆余年第二季', category: '古装', score: '9.0', trend: 'up', views: '1,960万' },
  { rank: 3, title: '周处除三害', category: '动作', score: '8.8', trend: 'up', views: '1,750万' },
  { rank: 4, title: '热辣滚烫', category: '喜剧', score: '8.5', trend: 'hot', views: '1,620万' },
  { rank: 5, title: '繁花', category: '剧情', score: '8.7', trend: 'up', views: '1,480万' },
  { rank: 6, title: '封神第二部', category: '奇幻', score: '8.4', trend: 'new', views: '1,320万' },
];

export const cards = [
  {
    id: 'c1', title: '暑期档必看：十部高分电影推荐', category: '编辑精选',
    desc: '暑假不知道看什么？我们为你精选了十部口碑爆棚的影片，从科幻巨制到温情小品，总有一部适合你。',
    image: 'https://readdy.ai/api/search-image?query=warm%20cinematic%20movie%20collage%20with%20film%20reel%20and%20popcorn%20on%20dark%20wood%20table%2C%20cozy%20home%20theater%20atmosphere%2C%20soft%20ambient%20lighting%2C%20golden%20hour%20tones%2C%20professional%20product%20photography%2C%20clean%20composition%2C%20warm%20neutral%20background%2C%20cinematic%20mood&width=800&height=500&seq=card-movie-summer-1&orientation=landscape'
  },
  {
    id: 'c2', title: '悬疑片单：烧脑反转停不下来', category: '类型专题',
    desc: '从经典推理到心理惊悚，这份悬疑片单带你体验层层反转的观影快感，每一部都让你欲罢不能。',
    image: 'https://readdy.ai/api/search-image?query=mysterious%20detective%20desk%20with%20magnifying%20glass%20and%20old%20photographs%2C%20dim%20warm%20lighting%2C%20vintage%20noir%20atmosphere%2C%20wooden%20surface%2C%20shallow%20depth%20of%20field%2C%20professional%20photography%2C%20warm%20amber%20tones%2C%20dramatic%20shadows&width=800&height=500&seq=card-movie-suspense-2&orientation=landscape'
  },
  {
    id: 'c3', title: '国产剧崛起：年度口碑佳作盘点', category: '剧集推荐',
    desc: '这一年国产剧质量持续走高，多部作品豆瓣评分破8，制作精良、演技在线的好剧值得反复品味。',
    image: 'https://readdy.ai/api/search-image?query=elegant%20Chinese%20period%20drama%20scene%20with%20traditional%20costume%20details%20on%20display%2C%20soft%20natural%20light%2C%20artistic%20composition%2C%20warm%20golden%20and%20coral%20palette%2C%20professional%20photography%2C%20clean%20neutral%20background%2C%20cinematic%20quality&width=800&height=500&seq=card-tv-chinese-3&orientation=landscape'
  },
  {
    id: 'c4', title: '动漫迷福利：热门番剧一网打尽', category: '动漫专区',
    desc: '热血、治愈、奇幻各类新番和经典番剧持续更新中，中文字幕同步上线，追番体验满分。',
    image: 'https://readdy.ai/api/search-image?query=colorful%20anime%20art%20style%20illustration%20props%20on%20desk%2C%20manga%20volumes%20and%20sketch%20papers%2C%20warm%20morning%20sunlight%2C%20creative%20workspace%2C%20soft%20pastel%20accents%2C%20professional%20photography%2C%20clean%20composition%2C%20artistic%20atmosphere&width=800&height=500&seq=card-anime-4&orientation=landscape'
  },
  {
    id: 'c5', title: '经典港片回顾：那些年我们追过的电影', category: '怀旧经典',
    desc: '周星驰、成龙、王家卫……港片黄金时代的经典作品值得每一代人重温，感受光影中的香港情怀。',
    image: 'https://readdy.ai/api/search-image?query=vintage%20Hong%20Kong%20street%20neon%20signs%20at%20dusk%2C%20cinematic%20mood%2C%20warm%20tungsten%20lighting%2C%20retro%20film%20aesthetic%2C%20professional%20photography%2C%20rich%20amber%20and%20coral%20tones%2C%20shallow%20depth%20of%20field&width=800&height=500&seq=card-hk-movie-5&orientation=landscape'
  },
  {
    id: 'c6', title: '周末影单：适合全家一起看的温馨电影', category: '主题策划',
    desc: '精选适合全家老少一起观看的影片，温馨感人又不失趣味，让周末的夜晚充满欢声笑语。',
    image: 'https://readdy.ai/api/search-image?query=cozy%20living%20room%20with%20large%20TV%20screen%20and%20comfortable%20sofa%2C%20family%20movie%20night%20atmosphere%2C%20warm%20string%20lights%2C%20soft%20blankets%2C%20golden%20evening%20light%2C%20professional%20photography%2C%20inviting%20composition%2C%20clean%20neutral%20background&width=800&height=500&seq=card-family-movie-6&orientation=landscape'
  },
  {
    id: 'c7', title: '纪录片频道：真实世界的震撼与感动', category: '纪录精选',
    desc: '自然、历史、人文、科技——纪录片带你探索世界的广度与深度，每一帧都是真实的力量。',
    image: 'https://readdy.ai/api/search-image?query=cinematic%20nature%20documentary%20scene%20with%20vintage%20camera%20on%20wooden%20desk%2C%20world%20map%20background%2C%20warm%20natural%20light%2C%20exploration%20theme%2C%20professional%20photography%2C%20earthy%20golden%20tones%2C%20clean%20composition%2C%20adventure%20mood&width=800&height=500&seq=card-doc-7&orientation=landscape'
  },
];

export const indexItems = [
  { id: 'i1', name: '科幻电影', icon: 'ri-rocket-2-line', count: 386 },
  { id: 'i2', name: '动作大片', icon: 'ri-fire-line', count: 512 },
  { id: 'i3', name: '喜剧天堂', icon: 'ri-emotion-laugh-line', count: 428 },
  { id: 'i4', name: '悬疑惊悚', icon: 'ri-ghost-smile-line', count: 294 },
  { id: 'i5', name: '爱情文艺', icon: 'ri-heart-line', count: 357 },
  { id: 'i6', name: '国产热剧', icon: 'ri-tv-line', count: 673 },
  { id: 'i7', name: '韩剧精选', icon: 'ri-kakao-talk-line', count: 441 },
  { id: 'i8', name: '动漫番剧', icon: 'ri-gamepad-line', count: 529 },
  { id: 'i9', name: '纪录世界', icon: 'ri-global-line', count: 218 },
];

export const updates = [
  { id: 'u1', date: '08-01', title: '《流浪地球3》高清版正式上线', tag: '新片上线' },
  { id: 'u2', date: '07-31', title: '《庆余年第二季》全集更新完毕', tag: '剧集完结' },
  { id: 'u3', date: '07-30', title: '暑期观影季专题上线，百部佳片推荐', tag: '站内活动' },
  { id: 'u4', date: '07-29', title: '播放器升级至H.265编码，画质提升30%', tag: '功能更新' },
  { id: 'u5', date: '07-28', title: '新增韩剧专区，热门韩综同步更新', tag: '内容扩展' },
  { id: 'u6', date: '07-27', title: '《周处除三害》评分破8.8，口碑持续走高', tag: '热门推荐' },
  { id: 'u7', date: '07-26', title: '服务器全面升级，观影缓冲时间缩短80%', tag: '体验优化' },
  { id: 'u8', date: '07-25', title: '纪录片频道改版，新增4K专区', tag: '频道更新' },
  { id: 'u9', date: '07-24', title: '《热辣滚烫》上线首周播放量突破千万', tag: '数据捷报' },
];

export const features = [
  {
    id: 'f1', icon: 'ri-4k-line', title: '高清画质',
    desc: '主流影片支持1080P至4K超清画质，H.265高效编码在保证清晰度的同时大幅降低流量消耗，手机观看也流畅。'
  },
  {
    id: 'f2', icon: 'ri-flashlight-line', title: '极速加载',
    desc: '全国多节点CDN加速，智能匹配最优线路。首帧加载快至1.5秒，拖动进度条几乎零等待，告别转圈焦虑。'
  },
  {
    id: 'f3', icon: 'ri-shield-check-line', title: '免费无广告',
    desc: '坚持免费观影理念，全站无弹窗广告、无强制注册。打开浏览器即可观看，观影过程不被打断。'
  },
  {
    id: 'f4', icon: 'ri-smartphone-line', title: '多端适配',
    desc: '完美适配手机、平板和电脑屏幕，支持投屏功能。通勤路上、午休时间、周末宅家，随时随地畅享影视。'
  },
];

export const contactInfo = {
  email: 'service@luobomovie.com',
  wechat: '萝卜影视小助手',
  description: '无论是影片推荐、内容反馈还是商务合作，都欢迎联系我们。你的每一个建议都是萝卜影视成长的动力！',
};

export const appInfo = {
  title: '萝卜影视移动版',
  description: '扫码下载萝卜影视APP，随时随地畅享高清影视。移动端专属优化，流量更省，加载更快！',
  platforms: ['iOS', 'Android', 'iPad'],
};

export const userComments = [
  {
    id: 'cm1', avatar: 'https://readdy.ai/api/search-image?query=young%20asian%20person%20portrait%20with%20warm%20lighting%2C%20natural%20expression%2C%20soft%20background%2C%20professional%20headshot%2C%20clean%20composition&width=120&height=120&seq=avatar-user-1&orientation=squarish',
    name: '追剧达人小陈', time: '2小时前', rating: 5,
    content: '从去年开始用萝卜影视，资源更新真的快！新片院线下映没多久就能看了，画质也清晰，关键是免费，良心平台！'
  },
  {
    id: 'cm2', avatar: 'https://readdy.ai/api/search-image?query=mature%20asian%20woman%20portrait%20with%20warm%20lighting%2C%20gentle%20smile%2C%20soft%20background%2C%20professional%20headshot%2C%20clean%20composition&width=120&height=120&seq=avatar-user-2&orientation=squarish',
    name: '周末影迷小周', time: '5小时前', rating: 5,
    content: '分类做得很细致，找片子特别方便。最近在补港片经典系列，画质修复得不错，怀旧感拉满，好评！'
  },
  {
    id: 'cm3', avatar: 'https://readdy.ai/api/search-image?query=young%20asian%20man%20portrait%20with%20warm%20lighting%2C%20friendly%20expression%2C%20soft%20background%2C%20professional%20headshot%2C%20clean%20composition&width=120&height=120&seq=avatar-user-3&orientation=squarish',
    name: '动漫宅阿杰', time: '8小时前', rating: 4,
    content: '番剧更新速度和B站差不多，而且不用大会员。字幕翻译质量也不错，追番体验很满意，希望动漫区越做越好。'
  },
  {
    id: 'cm4', avatar: 'https://readdy.ai/api/search-image?query=mature%20asian%20man%20portrait%20with%20warm%20lighting%2C%20calm%20expression%2C%20soft%20background%2C%20professional%20headshot%2C%20clean%20composition&width=120&height=120&seq=avatar-user-4&orientation=squarish',
    name: '电影发烧友老张', time: '1天前', rating: 5,
    content: '作为一个看了三十年电影的老影迷，萝卜影视的片库深度让我惊喜。很多冷门文艺片都能找到，播放也很流畅。'
  },
  {
    id: 'cm5', avatar: 'https://readdy.ai/api/search-image?query=young%20asian%20woman%20portrait%20with%20warm%20lighting%2C%20bright%20smile%2C%20soft%20background%2C%20professional%20headshot%2C%20clean%20composition&width=120&height=120&seq=avatar-user-5&orientation=squarish',
    name: '宿舍追剧小分队', time: '2天前', rating: 5,
    content: '宿舍四个人都在用！晚上一起投屏看综艺太欢乐了。片源稳定不卡顿，已经安利给隔壁寝室了，都来加入萝卜大军吧！'
  },
];

export const faqItems = [
  {
    id: 'faq1', question: '萝卜影视需要注册或付费吗？',
    answer: '完全不需要！萝卜影视坚持免费观影理念，所有电影和电视剧均可直接在线观看，无需注册账号，无需支付任何费用。我们的目标是让每一个人都能零门槛享受影视的乐趣。'
  },
  {
    id: 'faq2', question: '视频加载慢或卡顿怎么办？',
    answer: '萝卜影视采用全国多节点CDN加速和H.265高效编码技术，通常播放非常流畅。如果偶遇卡顿，可以尝试切换备用线路（播放器右下角有线路切换按钮），或稍降一档清晰度。大部分情况下1080P都能流畅观看。'
  },
  {
    id: 'faq3', question: '影片多久更新一次？有哪些内容？',
    answer: '我们每天更新60部以上的影片内容，覆盖最新的院线大片、热门电视剧、经典老片、动漫番剧和纪录片等。新片从院线下映到上线萝卜影视的周期通常为2-4周，热门剧集与平台同步更新。'
  },
  {
    id: 'faq4', question: '支持手机观看和投屏吗？',
    answer: '支持的！萝卜影视完美适配手机、平板和电脑端，网页版无需下载即可观看。同时支持AirPlay和DLNA投屏功能，可以将影片投射到电视大屏上，享受家庭影院的观影体验。'
  },
];

export const mediaCards = [
  {
    id: 'm1', title: '本周热门推荐：《流浪地球3》深度解析', duration: '15:28', views: '86万',
    image: 'https://readdy.ai/api/search-image?query=cinematic%20sci-fi%20space%20scene%20with%20earth%20and%20stars%2C%20dramatic%20lighting%2C%20epic%20composition%2C%20warm%20golden%20and%20deep%20coral%20tones%2C%20movie%20poster%20aesthetic%2C%20professional%20cinematography%2C%20clean%20dark%20background%2C%20atmospheric%20mood&width=800&height=450&seq=media-scifi-1&orientation=landscape'
  },
  {
    id: 'm2', title: '高分悬疑剧盘点：每一部都让你猜不到结局', duration: '22:06', views: '64万',
    image: 'https://readdy.ai/api/search-image?query=mysterious%20shadow%20silhouette%20in%20warm%20amber%20light%2C%20film%20noir%20atmosphere%2C%20dramatic%20contrast%2C%20cinematic%20composition%2C%20professional%20photography%2C%20suspenseful%20mood%2C%20clean%20dark%20background%2C%20golden%20highlights&width=800&height=450&seq=media-suspense-2&orientation=landscape'
  },
  {
    id: 'm3', title: '暑期档观影指南：这份片单请收好', duration: '18:42', views: '52万',
    image: 'https://readdy.ai/api/search-image?query=summer%20evening%20outdoor%20cinema%20setup%20with%20string%20lights%2C%20comfortable%20seating%2C%20warm%20golden%20sunset%20glow%2C%20festive%20atmosphere%2C%20professional%20photography%2C%20cinematic%20mood%2C%20clean%20composition%2C%20cozy%20vibes&width=800&height=450&seq=media-summer-3&orientation=landscape'
  },
];

export const carouselItems = [
  {
    id: 'cr1', title: '科幻巨制《流浪地球3》全网首播',
    category: '焦点推荐',
    desc: '人类命运共同体的终极篇章，视觉特效全面升级，吴京、刘德华领衔主演，票房口碑双丰收的年度科幻大作。',
    image: 'https://readdy.ai/api/search-image?query=epic%20sci-fi%20space%20station%20interior%20with%20warm%20lighting%2C%20futuristic%20control%20room%2C%20cinematic%20wide%20shot%2C%20dramatic%20atmosphere%2C%20golden%20and%20amber%20highlights%2C%20professional%20cinematography%2C%20clean%20composition%2C%20atmospheric%20depth&width=1200&height=600&seq=carousel-scifi-1&orientation=landscape'
  },
  {
    id: 'cr2', title: '古装权谋《庆余年第二季》全季上线',
    category: '热播剧集',
    desc: '张若昀、陈道明等原班人马回归，剧情全面升级，权谋与笑点并存，豆瓣评分稳定9.0的年度古装神作。',
    image: 'https://readdy.ai/api/search-image?query=elegant%20traditional%20Chinese%20palace%20courtyard%20with%20warm%20sunlight%2C%20classical%20architecture%2C%20cinematic%20wide%20composition%2C%20rich%20golden%20and%20coral%20tones%2C%20professional%20photography%2C%20atmospheric%20depth%2C%20clean%20sky%20background&width=1200&height=600&seq=carousel-period-2&orientation=landscape'
  },
  {
    id: 'cr3', title: '动作爽片《周处除三害》热映中',
    category: '口碑佳作',
    desc: '阮经天颠覆性演出，拳拳到肉的动作场面与层层反转的剧情，华语动作片新标杆，豆瓣8.8高分认证。',
    image: 'https://readdy.ai/api/search-image?query=dynamic%20urban%20night%20street%20scene%20with%20warm%20neon%20lights%2C%20cinematic%20wide%20composition%2C%20action%20movie%20aesthetic%2C%20dramatic%20lighting%2C%20rich%20amber%20and%20golden%20tones%2C%20professional%20photography%2C%20atmospheric%20mood&width=1200&height=600&seq=carousel-action-3&orientation=landscape'
  },
  {
    id: 'cr4', title: '喜剧爆款《热辣滚烫》欢笑上线',
    category: '喜剧专区',
    desc: '贾玲导演新作，笑中带泪的温暖故事。减肥百斤的真实蜕变与动人演绎，春节档票房冠军，全民讨论的现象级作品。',
    image: 'https://readdy.ai/api/search-image?query=warm%20and%20bright%20living%20room%20with%20sunlight%20streaming%20in%2C%20cozy%20atmosphere%2C%20cinematic%20wide%20composition%2C%20cheerful%20and%20uplifting%20mood%2C%20golden%20hour%20lighting%2C%20professional%20photography%2C%20clean%20composition&width=1200&height=600&seq=carousel-comedy-4&orientation=landscape'
  },
  {
    id: 'cr5', title: '史诗奇幻《封神第二部》震撼归来',
    category: '奇幻巨制',
    desc: '乌尔善导演打造的中国神话史诗续作，视觉奇观全面升级。神仙斗法的宏大场面，东方美学的极致呈现，不可错过。',
    image: 'https://readdy.ai/api/search-image?query=epic%20mythological%20Chinese%20landscape%20with%20ancient%20temples%20and%20mountains%2C%20dramatic%20clouds%2C%20cinematic%20wide%20composition%2C%20warm%20golden%20sunset%20light%2C%20fantasy%20atmosphere%2C%20professional%20photography%2C%20rich%20amber%20and%20coral%20tones&width=1200&height=600&seq=carousel-fantasy-5&orientation=landscape'
  },
];

export const aboutInfo = {
  title: '关于萝卜影视',
  paragraphs: [
    '萝卜影视是一个致力于为影迷提供免费高清影视内容的在线观影平台。自上线以来，我们始终坚持"零门槛、高品质"的核心理念，让每一位用户都能轻松享受电影和电视剧带来的快乐。',
    '我们的片库涵盖院线大片、热门剧集、经典老片、动漫番剧、纪录片等多种类型，每日更新60余部内容。依托先进的视频编码技术和全国分布式CDN加速网络，萝卜影视在保证高清画质的同时实现了极速加载和流畅播放。',
    '萝卜影视团队由一群热爱影视的年轻开发者组成。我们相信，好的内容应该被更多人看到。未来，我们将持续扩大片库规模，优化观影体验，让萝卜影视成为你观影追剧的首选平台。',
  ],
  stats: [
    { value: '12,800+', label: '收录影片' },
    { value: '60+', label: '每日更新' },
    { value: '860万+', label: '月活用户' },
    { value: '99.9%', label: '服务可用率' },
  ],
};